import { deserialize } from 'cerialize'
import { ShortDataModel, AddressSuggest } from 'Models'
import {
	OrderFields,
	OrderStatus,
	OrderStatusTranslate,
	FileModel,
	ReserveAccountModel,
	StatusReserveAccount,
	RBIDOS_TYPES,
	ContactDetails,
	StatusEvent,
	OrderPermission,
	OrderProductModel,
	UnBlockRequest,
	optionsFile,
	CommentModel,
	ORDER_SOURCE_TYPE,
} from 'Pages/orders_design'
import { GuaranteeType } from 'Pages/ibro'
import { PartnerRequestInfo } from 'src/pages/partnerRequests'
import { RbidosLeadModel } from 'Pages/lead'

export class OrderModel {
	@deserialize public account_bank_bic: string
	@deserialize public account_by_sber_online: boolean
	@deserialize public account_number: string
	@deserialize public add_info: string
	@deserialize public attachments: FileModel[]
	@deserialize public autocreated: boolean
	@deserialize public approve?: boolean
	@deserialize public call_me: boolean | null
	@deserialize public channel: ShortDataModel
	@deserialize public city_id: number
	@deserialize public comments: CommentModel[]
	@deserialize public company_name: string
	@deserialize public contact_details: ContactDetails
	@deserialize public created_at: string
	@deserialize public created_by_user: ShortDataModel
	@deserialize public deal_amount: number
	@deserialize public deal_subject_id: number
	@deserialize public decision_maker_email: string
	@deserialize public decision_maker_person_name: string
	@deserialize public decision_maker_phone: string
	@deserialize public decision_maker_person_first_name: string
	@deserialize public decision_maker_person_last_name: string
	@deserialize public decision_maker_person_middle_name: string
	@deserialize public eks_date: string
	@deserialize public equip_amount: number
	@deserialize public equip_connect_type: string // NC-3559 возможность enum
	@deserialize public equip_type: string // NC-3559 возможность enum
	@deserialize public equip_type_ru: string // NC-3559 возможность enum
	@deserialize public events?: StatusEvent[]
	@deserialize public fields: OrderFields[]
	@deserialize public final_decision: {
		status: OrderStatus
		created_at: string
	}
	@deserialize public deal_subject: {
		id: number
		name: string
	}
	@deserialize public finance_person_name: string
	@deserialize public finance_person_email: string
	@deserialize public file: File | File[] // нужны для фронта, хранятся файлы до отправки на сервер
	@deserialize public id: number
	@deserialize public inn: string
	@deserialize public kpp: string | null
	@deserialize public ogrn: string | null
	@deserialize public okfs_manual: string | null
	@deserialize public okfs: string | null
	@deserialize public okopf: string | null

	@deserialize public install_region: ShortDataModel
	@deserialize public install_region_id: number
	@deserialize public install_date: Date
	@deserialize public is_deleted: boolean
	@deserialize public manager: {
		id: number
		name: string
		territorial_bank: { id: number; name: string; code: string }
	}
	@deserialize public manager_name: string
	@deserialize public manager_phone: string
	@deserialize public manager_email: string
	@deserialize public manager_first_name: string
	@deserialize public manager_last_name: string
	@deserialize public manager_middle_name: string
	@deserialize public mcc_code: ShortDataModel
	@deserialize public mcc_code_id: number
	@deserialize public merchants: ShortDataModel[]
	@deserialize public merchant_branch: {
		address: string
		id: number
		is_deleted: boolean
		name: string
	}
	@deserialize public merchant_branch_id: number

	@deserialize public notice_number: string
	@deserialize public number: string
	@deserialize public online_product_ids: number[]
	@deserialize public online_manager_product_ids: number[]
	@deserialize public operation_average_sum: number

	@deserialize public orgaddress: string
	@deserialize public orgaddress_fias_guid: string
	@deserialize public orgaddress_fias_lvl: string
	@deserialize public partner: {
		id: number
		name: string
		vat_number: string
	}
	@deserialize public permissions: OrderPermission
	@deserialize public pos_name: string
	@deserialize public posaddress: AddressSuggest
	@deserialize public posaddress_fias_guid: string
	@deserialize public posaddress_fias_lvl: string
	@deserialize public product_order_relations: {
		product_id: number
		recommendation_id: number | null
		external_id: string
		events: StatusEvent[]
	}[]
	@deserialize public products: OrderProductModel[]
	@deserialize public questions_contact_phone: string
	@deserialize public rbidos_request: {
		id: number
		created_at: string
		with_reserve_account: boolean
		scenario: RBIDOS_TYPES
	}
	@deserialize public 'readed?': boolean
	@deserialize public region: ShortDataModel
	@deserialize public rbidos: boolean // нужен на фронте, данные о том, что нужен файл-заглушка для перезакрепления
	@deserialize public region_id: number
	@deserialize public city: ShortDataModel
	@deserialize public required_fields: OrderFields[]
	@deserialize public fixed_fields: OrderFields[]

	@deserialize public status: OrderStatusTranslate
	@deserialize public status_code: OrderStatus
	@deserialize public turn_over: number

	@deserialize public unblock_request: UnBlockRequest
	@deserialize public with_sms_bearer_lead: boolean

	@deserialize public updated_at: string
	@deserialize public user_channel: string
	@deserialize public rate: string
	@deserialize public product_order_relation_recommendations?: { [key: string]: number }
	@deserialize public product_order_relation_latent_recommendations?: { [key: string]: number }
	@deserialize public recommendation_product_ids?: number[]
	@deserialize public special_offer: ShortDataModel
	@deserialize public sbercrm_id?: string
	@deserialize public lot_number?: string
	@deserialize public customer_inn?: string
	@deserialize public guaranteetype?: GuaranteeType
	@deserialize public partner_request_order_agreement_answer_required: PartnerRequestInfo

	public get mcc_code_name(): string | undefined {
		return this?.mcc_code?.name
	}

	public get install_region_name(): string | undefined {
		return this?.install_region?.name
	}

	@deserialize public attachments_attributes?: { file: File }[] | File[] // для отправки файлов
	@deserialize public unblock_request_attributes?: {
		rbidos: boolean
		files_attributes: {
			file: File
			file_file_name: string
		}[]
	}

	@deserialize public fixed_products: boolean
	@deserialize public reserve_account: ReserveAccountModel | null
	@deserialize public possibility_to_reserve_an_account: boolean
	@deserialize public expect_reserve_account: boolean
	@deserialize public bg_request: { id: number; created_at: string }
	@deserialize public department_id?: number
	@deserialize public department?: null | Pick<ShortDataModel, 'id' | 'name'>
	@deserialize public name: string
	@deserialize public status_reserve_account: StatusReserveAccount
	@deserialize public sber_geo_unit_branch_address_string?: string
	@deserialize public sber_geo_unit_code_nsi?: number
	@deserialize public sber_geo_unit_address_string?: AddressSuggest
	@deserialize public otkritie_bank_city?: string
	@deserialize public external_form_id: number | null
	@deserialize public lead: RbidosLeadModel | null
	@deserialize public phone: string | null
	@deserialize public email: string
	@deserialize public first_name: string
	@deserialize public last_name: string
	@deserialize public middle_name: string
	@deserialize public files_options: Record<string, optionsFile>
	@deserialize public iframe?: boolean
	@deserialize public autoorder_source?: string
	@deserialize public order_source: ORDER_SOURCE_TYPE | null
	@deserialize public area_name: string
	@deserialize public autoorder_created_at?: string
	@deserialize public partner_registration_date?: string
	@deserialize public match_order?: { id: number | null; created_at: string | null }
}
